import { Box, Typography, useTheme } from "@material-ui/core";
import React from "react";
import { LENDER_APPROVAL_STATUS } from "../../../../../../config/config";
import Text from "../../../../../shared/components/Text";

export const LoanApplicationStatusTag = ({
  loanApplication,
  variant = "large",
}) => {
  const { customBorderRadius, palette } = useTheme();
  const params = getLoanApplicationStatusTagProps(
    loanApplication.lender_fields.loan_application_status.lender_approval_status
  );

  if (variant === "small") {
    return (
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={20}
        height={20}
        bgcolor={palette[params.type].light}
        borderRadius={"50%"}
      >
        <i
          className="material-icons-outlined"
          style={{
            fontSize: "14px",
            color: palette[params.type].main,
            fontWeight: 700,
          }}
        >
          {params.icon}
        </i>
      </Box>
    );
  }

  return (
    <Box
      px={1}
      position="relative"
      height={20}
      display={"inline-flex"}
      justifyContent={"center"}
      alignItems={"center"}
      borderRadius={customBorderRadius.chip}
      boxSizing={"border-box"}
      overflow="hidden"
      bgcolor={palette[params.type].light}
      {...params}
    >
      <Typography
        variant="caption"
        style={{
          color: palette[params.type][params.colorType],
        }}
      >
        <Text strong tId={params.labelTextId} />
      </Typography>
    </Box>
  );
};

export const getLoanApplicationStatusTagProps = (approvalStatus) => {
  switch (approvalStatus) {
    case LENDER_APPROVAL_STATUS.YES:
      return {
        type: "success",
        colorType: "main",
        labelTextId: "ANSWERED_YES",
        icon: "check",
      };
    case LENDER_APPROVAL_STATUS.NO:
      return {
        type: "error",
        colorType: "main",
        labelTextId: "ANSWERED_NO",
        icon: "cancel",
      };
    default:
      return {
        type: "info",
        colorType: "main",
        labelTextId: "IN_STUDY",
        icon: "help",
      };
  }
};
